import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getActivities, getRecentClocks, getWarehouses} from '../../reducer';
import {Accordion, Icon, Table} from 'semantic-ui-react';
import moment from 'moment';
import {Translate} from 'react-localize-redux';

class RecentClockList extends Component {

    state = {activeIndex: null};

    handleClick = (e, titleProps) => {
        const {index} = titleProps;
        const {activeIndex} = this.state;
        const newIndex = activeIndex === index ? -1 : index;

        this.setState({activeIndex: newIndex})
    };

    render() {
        const {activeIndex} = this.state;
        return (
            <Translate>
                {({translate}) =>
                    <Accordion styled>
                        <Accordion.Title
                            active={activeIndex === 0}
                            index={0}
                            onClick={this.handleClick}
                        >
                            <Icon name='dropdown'/>
                            {translate('clock.recent')}
                        </Accordion.Title>
                        <Accordion.Content
                            active={activeIndex === 0}
                        >
                            <Table celled stackable style={{textAlign: 'left'}}>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>{translate('clock.warehouse.label')}</Table.HeaderCell>
                                        <Table.HeaderCell>{translate('clock.activities.label')}</Table.HeaderCell>
                                        <Table.HeaderCell>{translate('general.from')}</Table.HeaderCell>
                                        <Table.HeaderCell>{translate('general.until')}</Table.HeaderCell>
                                        <Table.HeaderCell>{translate('general.duration')} [h]</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {this.props.recentClocks !== null && this.props.recentClocks.map((clock) => (
                                        <Table.Row key={clock.id}>
                                            <Table.Cell>
                                                {this.props.warehouses.find((element) => (element.id === clock.warehouse_id)).name}
                                            </Table.Cell>
                                            <Table.Cell> {translate('clock.activities.' + this.props.activities.find((element) => (element.id === clock.activity_id)).name)}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {moment(clock.start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm DD.MM.YYYY ')}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {moment(clock.end, 'YYYY-MM-DD HH:mm:ss').format('HH:mm DD.MM.YYYY ')}
                                            </Table.Cell>
                                            <Table.Cell>
                                                {Math.round(Math.abs(Date.parse(clock.start) - Date.parse(clock.end)) / 36e3) / 100}
                                            </Table.Cell>
                                        </Table.Row>
                                    ))}
                                </Table.Body>
                            </Table>
                        </Accordion.Content>
                    </Accordion>
                }
            </Translate>
        )
    }
}

const mapStateToProps = state => ({
    warehouses: getWarehouses(state),
    activities: getActivities(state),
    recentClocks: getRecentClocks(state)
});


function mergeProps(stateProps, dispatchProps, ownProps) {

    return {
        ...dispatchProps,
        ...stateProps,
        ...ownProps
    }
}

const mapDispatchToProps = (dispatch) => {
    return ({})
};


// No need to connect()!
export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(RecentClockList)



// WEBPACK FOOTER //
// ./src/scenes/Clock/components/RecentClockList/index.js